/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * SideBarItem Component
 *
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.3.1
 */

import { fonts } from '../../../theme';
import { LinkBlock, TextBlock } from '../index';
import { SideBarNavItemStyled } from './styled/SideBarItemStyled';
import { ISideBarItem } from './types/SideBarTypes';

interface ISideBarItemProps {
    isActive: boolean;
    isExternalUrl?: boolean;
    item: ISideBarItem;
    onClick: () => void;
}

const SideBarItem = (props: ISideBarItemProps) => {
    return <LinkBlock
        data-index={props.item.value}
        isExternalUrl={props.isExternalUrl}
        url={props.item.url}
        onClick={props.onClick}
    >
        <SideBarNavItemStyled
            isActive={props.isActive}
        >
            <TextBlock
                font={props.isActive ? fonts.textMainBold : fonts.textMain}
            >
                {props.item.label}
            </TextBlock>
        </SideBarNavItemStyled>
    </LinkBlock>
};

export default SideBarItem;
